import React from 'react';
import '../style/about.css';
import { Container, Row, Col } from 'react-bootstrap';
import thankyou from '../assets/thankyou.png';

const AboutUs = () => {
  return (
    <div>
    <section className="thankyoubanner" >
     <Container>
        <Row>
            <Col md={12}>
               <img src={thankyou} />
               <a href='/Home'>Back To Home</a>
            </Col>
        </Row>
     </Container>
    </section>
    </div>
  );
};


export default AboutUs;
